function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var antPrefixCls = '.ant-btn';
//test
var genDisabledStyle = function genDisabledStyle(style) {
  var _ref;
  return _ref = {}, _ref["&:disabled:not(" + antPrefixCls + "-background-ghost)"] = _extends({}, style), _ref["&" + antPrefixCls + "-disabled"] = _extends({}, style), _ref;
};

// ============================== Shared ==============================
var genSharedButtonStyle = function genSharedButtonStyle(token) {
  var _ref2;
  return _ref2 = {}, _ref2["" + antPrefixCls] = {
    fontWeight: 500,
    gap: 4
  }, _ref2[antPrefixCls + "-link:disabled"] = {
    color: token.colorPrimaryBgHover
  }, _ref2;
};
var genHoverActiveButtonStyle = function genHoverActiveButtonStyle(hoverStyle, activeStyle) {
  var _ref3;
  return _ref3 = {}, _ref3["&:not(:disabled):not(" + antPrefixCls + "-disabled):not(" + antPrefixCls + "-background-ghost)"] = {
    '&:hover': hoverStyle,
    '&:active': activeStyle
  }, _ref3;
};

// =============================== Type ===============================
// Type: Default
var genDefaultDisabledStyle = function genDefaultDisabledStyle(token) {
  return _extends({}, genDisabledStyle({
    color: token.colorTextDisabled,
    // borderColor: token.colorBorderDisabled,
    backgroundColor: token.colorFillSecondary
  }));
};
var genDefaultButtonStyle = function genDefaultButtonStyle(token) {
  return _extends({
    boxShadow: 'none'
  }, genDefaultDisabledStyle(token));
};
var genDangerDisabledStyle = function genDangerDisabledStyle(token) {
  var _ref4;
  return _ref4 = {}, _ref4["&" + antPrefixCls + "-dangerous"] = _extends({}, genDisabledStyle({
    color: token.colorErrorDisabledText
  })), _ref4;
};

// Type: Primary
var genPrimaryStyle = function genPrimaryStyle(token) {
  var _extends2, _extends3;
  return _extends({
    boxShadow: 'none'
  }, genDisabledStyle({
    color: token.colorPrimaryBg,
    backgroundColor: token.colorPrimaryBgDisabled,
    borderColor: token.colorPrimaryBgDisabled
  }), (_extends3 = {}, _extends3["&" + antPrefixCls + "-dangerous"] = _extends((_extends2 = {
    boxShadow: 'none'
  }, _extends2["&:not(:disabled):not(&" + antPrefixCls + "-disabled):not(&" + antPrefixCls + "-background-ghost)"] = {
    '&:active': {
      backgroundColor: token.colorErrorTextActive
    }
  }, _extends2), genDisabledStyle({
    color: token.colorWhite,
    backgroundColor: token.colorErrorDisabledBg,
    borderColor: token.colorErrorDisabledBg
  })), _extends3));
};

// Type: Text
var genTextButtonStyle = function genTextButtonStyle(token) {
  return _extends({}, genHoverActiveButtonStyle({
    color: token.colorPrimaryText
  }, {
    color: token.colorPrimaryTextActive,
    backgroundColor: token.colorTextButtonActive
  }), genDisabledStyle({
    color: token.colorPrimaryBgHover
  }), genDangerDisabledStyle(token));
};
var genTypeButtonStyle = function genTypeButtonStyle(token) {
  var _ref5;
  return _ref5 = {}, _ref5[antPrefixCls + "-default"] = genDefaultButtonStyle(token), _ref5[antPrefixCls + "-primary"] = genPrimaryStyle(token), _ref5[antPrefixCls + "-dashed"] = genDefaultButtonStyle(token), _ref5[antPrefixCls + "-text"] = genTextButtonStyle(token), _ref5[antPrefixCls + "-link"] = genDangerDisabledStyle(token), _ref5;
};
var buttonStyleFn = function buttonStyleFn(token) {
  return [genSharedButtonStyle(token), genTypeButtonStyle(token)];
};

export { buttonStyleFn };
